<template>
  <div class="infobox">
    <div class="infobox-icon">
      <span>
        <aha-icon name="information" class="text-primary-90" />
      </span>
    </div>
    <p
      class="flex-grow px-2 py-3 text-base-90"
      :class="[`text-${textSize}`]"
      v-if="!this.$slots.default"
    >
      {{ content }}
    </p>
    <slot />
  </div>
</template>

<script>
import AhaIcon from './Icon.vue'

export default {
  components: {
    AhaIcon,
  },
  props: {
    content: {
      type: String,
      default: '',
    },
    textSize: {
      type: String,
      default: 'xs',
    },
  },
}
</script>

<style lang="scss" scoped>
.infobox {
  @apply rounded-md flex border border-primary-80;
}

.infobox-icon {
  @apply flex justify-center items-center rounded-l-md;
  @apply w-8 flex-shrink-0 bg-primary-60 border-primary-80;
}
</style>
